import React from 'react';


function WelcomeBanner({user}) {


  const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return `Good Morning ${user?.firstName}`;
  if (hour < 18) return `Good Afternoon ${user?.firstName}`;
  return   `Good Evening ${user?.firstName}` ;
};

 const greeting = getGreeting()
  return (
    <div className="relative bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 p-6 sm:p-8 w-full rounded-2xl overflow-hidden mb-8 shadow-2xl">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute transform rotate-45 -top-24 -right-24 w-64 h-64 bg-white rounded-full"></div>
        <div className="absolute transform -rotate-45 -bottom-16 -left-16 w-48 h-48 bg-white rounded-full"></div>
      </div>

      {/* Background illustration */}
      <div className="absolute right-0 top-0 -mt-2 mr-16 pointer-events-none hidden xl:block opacity-20" aria-hidden="true">
        <svg width="319" height="198" xmlnsXlink="http://www.w3.org/1999/xlink">
          <defs>
            <path id="welcome-a" d="M64 0l64 128-64-20-64 20z" />
            <path id="welcome-e" d="M40 0l40 80-40-12.5L0 80z" />
            <path id="welcome-g" d="M40 0l40 80-40-12.5L0 80z" />
            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="welcome-b">
              <stop stopColor="#FFFFFF" offset="0%" />
              <stop stopColor="#E0E7FF" offset="100%" />
            </linearGradient>
            <linearGradient x1="50%" y1="24.537%" x2="50%" y2="100%" id="welcome-c">
              <stop stopColor="#FFFFFF" offset="0%" />
              <stop stopColor="#E0E7FF" stopOpacity="0" offset="100%" />
            </linearGradient>
          </defs>
          <g fill="none" fillRule="evenodd">
            <g transform="rotate(64 36.592 105.604)">
              <mask id="welcome-d" fill="#fff">
                <use xlinkHref="#welcome-a" />
              </mask>
              <use fill="url(#welcome-b)" xlinkHref="#welcome-a" />
              <path fill="url(#welcome-c)" mask="url(#welcome-d)" d="M64-24h80v152H64z" />
            </g>
            <g transform="rotate(-51 91.324 -105.372)">
              <mask id="welcome-f" fill="#fff">
                <use xlinkHref="#welcome-e" />
              </mask>
              <use fill="url(#welcome-b)" xlinkHref="#welcome-e" />
              <path fill="url(#welcome-c)" mask="url(#welcome-f)" d="M40.333-15.147h50v95h-50z" />
            </g>
            <g transform="rotate(44 61.546 392.623)">
              <mask id="welcome-h" fill="#fff">
                <use xlinkHref="#welcome-g" />
              </mask>
              <use fill="url(#welcome-b)" xlinkHref="#welcome-g" />
              <path fill="url(#welcome-c)" mask="url(#welcome-h)" d="M40.333-15.147h50v95h-50z" />
            </g>
          </g>
        </svg>
      </div>

      {/* Content */}
      <div className="relative">
        <h1 className="text-3xl md:text-4xl text-white font-extrabold mb-2 flex items-center gap-3">
          {greeting}
          <span className="text-4xl animate-bounce">👋</span>
        </h1>
        <p className="text-indigo-100 text-lg font-medium">Here is what's happening at the Garage today:</p>
      </div>
    </div>
  );
}

export default WelcomeBanner;
